import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconChecklistBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  ChecklistOperacionalPermissions,
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'
import { ROTAS_CHECKLIST } from '../../../../constants/checklist-operacional'

function ChecklistOperacionalMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.CHECKLIST_OPERACIONAL, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: ChecklistOperacionalPermissions.CADASTRO_CHECKLIST,
      content: { menu: '10.1 - Cadastro de Checklist', path: ROTAS_CHECKLIST.CADASTRO },
    },
    {
      id: ChecklistOperacionalPermissions.PREENCHIMENTO_CHECKLIST,
      content: { menu: '10.2 - Preenchimento de Checklist', path: ROTAS_CHECKLIST.PREENCHIMENTO },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconChecklistBlue} alt="Icon Tela de Checklist" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>10. Checklist</span>
      </PageMenu>{' '}
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ChecklistOperacionalMenu))
